<template>
  <v-application v-if="access.inv_stock_adjusment">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-crud-card
          name="stock adjustment"
          to="/inventory/stock"
          v-bind:headers="headers"
          v-bind:data="stock_adjustments"
          no-delete
          view
          v-bind:num-pages="stock_adjustments_total"
          v-model="stock_adjustments_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          v-bind:add_button_name="'add_stock_adjustment'"
          showSearch
          InventoryStock
          v-bind:search_text="search_text"
          v-bind:getData="update_stock_adjustments"
          v-bind:searchActivate="
            (state) => {
              search_text = state;
            }
          "
          v-bind:setText="
            (text) => {
              search = text;
            }
          "
        >
          <template #top>
            <v-combobox
              v-model="reason"
              :label="$t('reason')"
              v-bind:items="reasons"
              hide-details
              item-text="name"
              class="mx-1"
            />
            <v-combobox
              v-model="store"
              :label="$t('store')"
              v-bind:items="stores"
              hide-details
              item-text="name"
              class="mx-1"
            />
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else></error404>
</template>
<script>
import Services from "../../mixins/services";
import StockAdjustment from "../../mixins/inventory/stock_adjustment";
export default {
  name: "Stock",
  mixins: [Services, StockAdjustment],
  data: () => ({
    headers: [
      { text: "Adjustment", value: "p_order" },
      { text: "Date", value: "date" },
      { text: "Reason", value: "reason" },
      { text: "Store", value: "service_name" },
      { text: "Quantity", value: "quality" },
    ],
    data: [],
    search_text: false,
    search: "",
  }),
  methods: {
    changePagination(page) {
      this.stock_adjustments_page = page;
      this.update_stock_adjustments();
    },
  },
  mounted() {
    this.headers = [
      { text: this.$t("adjustment"), value: "p_order", available: true },
      { text: this.$t("date"), value: "date", available: true },
      { text: this.$t("reason"), value: "reason" , available: true},
      { text: this.$t("store"), value: "service_name" , available: true},
      { text: this.$t("quantity"), value: "quality", align: "center", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
  },
  watch: {
    store: {
      deep: true,
      handler() {
        this.$store.commit("setItemsService", this.store);
        this.update_stock_adjustments();
      },
    },
    reason: {
      deep: true,
      handler() {
        this.update_stock_adjustments();
      },
    },
  },
  beforeMount() {
    this.store = this.$store.state.items_current_service;
    this.access = this.$store.state.access;
  },
};
</script>